<template>
  <div
    v-if="isShow"
    ref="iuOverlay"
    class="iu-widget__overlay"
    :class="{ 'iu-widget--in-drag': inDrag }"
    @click="closePopup"
    @dragover.prevent.stop="inDrag = true"
    @dragleave.prevent.stop="inDrag = false"
    @drop.prevent.stop="uploadFromDrop"
  >
    <div v-if="settings.custom_style" v-html="settings.custom_style" />

    <GuideButton
      v-if="isGuidlineOpen === true"
      ref="frisbuyGuide"
      @toggle-guide="toggleGuide()"
      :html_guideline_block="settings.html_guideline_block"
    />
    <GuideButton
      v-if="isContentRulesOpen === true"
      @toggle-guide="closeContentRules()"
      :html_guideline_block="settings.html_content_rules_block"
    />

    <div
      ref="iuPopup"
      class="iu-widget__popup"
      @click.stop
      @dragover.prevent.stop="inDrag = true"
    >
      <template v-if="currentStep !== 'congrats'">
        <div class="iu-widget__header">
          <h3 class="iu-widget__title">
            {{ widgetTitle }}
          </h3>

          <button class="iu-widget__close" @click="closePopup">
            <svg
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.2179 0.29927L10.0005 8.10574L1.78319 0.29927C1.56545 0.113567 1.32093 0.0207157 1.04962 0.0207157C0.778322 0.0207157 0.53902 0.118854 0.331717 0.315131C0.124414 0.511408 0.0211099 0.738745 0.0218055 0.997144C0.0225012 1.25554 0.12024 1.48784 0.315021 1.69403L8.53236 9.50049L0.315021 17.307C0.0325882 17.5753 -0.0599327 17.8955 0.037458 18.2675C0.134849 18.6396 0.374151 18.8719 0.755366 18.9644C1.13658 19.0569 1.47884 18.969 1.78214 18.7007L9.99948 10.8943L18.2168 18.7007C18.4346 18.8864 18.6791 18.9793 18.9504 18.9793C19.2217 18.9793 19.461 18.8811 19.6683 18.6849C19.8756 18.4886 19.9789 18.2613 19.9782 18.0029C19.9775 17.7445 19.8798 17.5122 19.685 17.306L11.4676 9.4995L19.685 1.69303C19.9674 1.42472 20.0599 1.10453 19.9625 0.732467C19.8652 0.3604 19.6206 0.128106 19.229 0.0355851C18.8373 -0.056936 18.5003 0.0309588 18.2179 0.29927Z"
                fill="#303133"
              />
            </svg>
          </button>
        </div>

        <div class="iu-widget__post-form">
          <div class="post-form__person-info">
            <div class="input-form">
              <label
                class="iu-widget--required"
                :class="{
                  '--error': error && username.trim().length === 0,
                }"
              >
                Ваше имя
              </label>
              <input
                class="input-name"
                :class="{
                  'input--error': error && username.trim().length === 0,
                }"
                v-model="username"
                type="text"
                @input="error = null"
                placeholder="Имя"
              />
            </div>

            <div class="input-form">
              <label
                class="iu-widget--required"
                :class="{
                  '--error':
                    error && (email.length === 0 || !emailReg.test(email)),
                }"
              >
                Email
              </label>
              <input
                class="input-email"
                :class="{
                  'input--error':
                    error && (email.length === 0 || !emailReg.test(email)),
                }"
                v-model="email"
                type="text"
                @input="error = null"
                placeholder="Email"
              />
            </div>
          </div>

          <div class="post-form__customer-rating">
            <label
              class="iu-widget--required"
              :class="{
                '--error': error && rating === 0,
              }"
            >
              Как вам товар?
            </label>
            <StarRating v-model="rating" />
          </div>

          <div class="post-form__customer-review">
            <span class="customer-review__title">
              <span class="iu-widget--required">
                Расскажите о впечатлениях
              </span>
              <span class="customer-review__description">
                Заполните хотя бы одно поле
              </span>
            </span>

            <div class="customer-review__positive">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20.7633 12.51C21.157 11.9897 21.375 11.3522 21.375 10.6889C21.375 9.63654 20.7867 8.64045 19.8398 8.08498C19.5961 7.942 19.3185 7.86675 19.0359 7.86701H13.4156L13.5563 4.98654C13.5891 4.29045 13.343 3.62951 12.8648 3.1256C12.6302 2.87723 12.3471 2.67962 12.0331 2.54497C11.7191 2.41033 11.3807 2.34152 11.0391 2.34279C9.82031 2.34279 8.74219 3.1631 8.41875 4.33732L6.40547 11.6264H6.39844V21.6576H17.468C17.6836 21.6576 17.8945 21.6154 18.0891 21.5311C19.2047 21.0553 19.9242 19.9654 19.9242 18.7561C19.9242 18.4608 19.882 18.1701 19.7977 17.8889C20.1914 17.3686 20.4094 16.7311 20.4094 16.0678C20.4094 15.7725 20.3672 15.4819 20.2828 15.2006C20.6766 14.6803 20.8945 14.0428 20.8945 13.3795C20.8898 13.0842 20.8477 12.7912 20.7633 12.51ZM2.625 12.3764V20.9076C2.625 21.3225 2.96016 21.6576 3.375 21.6576H4.89844V11.6264H3.375C2.96016 11.6264 2.625 11.9615 2.625 12.3764Z"
                  fill="black"
                  fill-opacity="0.45"
                />
              </svg>
              <textarea
                v-model="positiveComment"
                :class="{
                  '--error':
                    error &&
                    !positiveComment &&
                    !negativeComment &&
                    !caption &&
                    !uploadedFiles.length,
                }"
                type="text"
                rows="1"
                placeholder="Опишите преимущества"
                :maxlength="textareaMaxLength"
              ></textarea>
            </div>
            <div class="customer-review__negative">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3.23672 11.4905C2.84297 12.0108 2.625 12.6483 2.625 13.3116C2.625 14.3639 3.21328 15.36 4.16016 15.9155C4.40392 16.0585 4.68146 16.1337 4.96406 16.1335H10.5844L10.4437 19.0139C10.4109 19.71 10.657 20.371 11.1352 20.8749C11.3698 21.1233 11.6529 21.3209 11.9669 21.4555C12.2809 21.5902 12.6193 21.659 12.9609 21.6577C14.1797 21.6577 15.2578 20.8374 15.5812 19.6632L17.5945 12.3741H17.6016V2.34285H6.53203C6.31641 2.34285 6.10547 2.38504 5.91094 2.46942C4.79531 2.9452 4.07578 4.03504 4.07578 5.24442C4.07578 5.53973 4.11797 5.83035 4.20234 6.1116C3.80859 6.63192 3.59063 7.26942 3.59063 7.9327C3.59063 8.22801 3.63281 8.51863 3.71719 8.79988C3.32344 9.3202 3.10547 9.9577 3.10547 10.621C3.11016 10.9163 3.15234 11.2093 3.23672 11.4905ZM21.375 11.6241V3.09285C21.375 2.67801 21.0398 2.34285 20.625 2.34285H19.1016V12.3741H20.625C21.0398 12.3741 21.375 12.0389 21.375 11.6241Z"
                  fill="black"
                  fill-opacity="0.45"
                />
              </svg>
              <textarea
                v-model="negativeComment"
                :class="{
                  '--error':
                    error &&
                    !positiveComment &&
                    !negativeComment &&
                    !caption &&
                    !uploadedFiles.length,
                }"
                type="text"
                rows="1"
                placeholder="Опишите недостатки"
                :maxlength="textareaMaxLength"
              ></textarea>
            </div>
            <div class="customer-review__comment">
              <textarea
                v-model="caption"
                :class="{
                  '--error':
                    error &&
                    !positiveComment &&
                    !negativeComment &&
                    !caption &&
                    !uploadedFiles.length,
                }"
                type="text"
                rows="1"
                placeholder="Комментарий"
                :maxlength="textareaMaxLength"
              ></textarea>
            </div>

            <div
              v-if="settings.html_guideline_button_text"
              v-html="settings.html_guideline_button_text"
              class="iu-widget-addpopup-btn"
            ></div>
          </div>
        </div>

        <div v-if="!limitIsFull && !uploadProcess" class="iu-widget-upload">
          <button class="iu-widget-upload__button">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.63196 3.34022C6.88158 3.02056 7.25951 2.83447 7.6591 2.83447H11.3413C11.7409 2.83447 12.1188 3.02056 12.3684 3.34022L13.3911 4.64988C13.4189 4.6854 13.4609 4.70608 13.5053 4.70608H16.4425C17.5725 4.70608 18.4886 5.64457 18.4886 6.80227V13.9144C18.4886 15.0721 17.5725 16.0106 16.4425 16.0106H2.55787C1.42781 16.0106 0.511719 15.0721 0.511719 13.9144V6.80227C0.511719 5.64457 1.42781 4.70608 2.55787 4.70608H5.49511C5.53951 4.70608 5.5815 4.6854 5.60924 4.64988L6.63196 3.34022ZM7.6591 4.0323C7.6147 4.0323 7.57271 4.05297 7.54497 4.08849L6.52225 5.39816C6.27263 5.71782 5.8947 5.9039 5.49511 5.9039H2.55787C2.07356 5.9039 1.68095 6.30612 1.68095 6.80227V13.9144C1.68095 14.4105 2.07356 14.8127 2.55787 14.8127H16.4425C16.9268 14.8127 17.3194 14.4105 17.3194 13.9144V6.80227C17.3194 6.30612 16.9268 5.9039 16.4425 5.9039H13.5053C13.1057 5.9039 12.7277 5.71782 12.4781 5.39816L11.4554 4.08849C11.4277 4.05297 11.3857 4.0323 11.3413 4.0323H7.6591Z"
                fill="#303133"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.49955 12.7166C10.8718 12.7166 11.9842 11.577 11.9842 10.1712C11.9842 8.76541 10.8718 7.6258 9.49955 7.6258C8.12733 7.6258 7.01493 8.76541 7.01493 10.1712C7.01493 11.577 8.12733 12.7166 9.49955 12.7166ZM9.49955 13.9144C11.5175 13.9144 13.1534 12.2385 13.1534 10.1712C13.1534 8.10387 11.5175 6.42798 9.49955 6.42798C7.48159 6.42798 5.8457 8.10387 5.8457 10.1712C5.8457 12.2385 7.48159 13.9144 9.49955 13.9144Z"
                fill="#303133"
              />
            </svg>

            <span class="iu-widget-upload__text">Добавить фото и видео</span>

            <input
              title="Добавить Фото"
              type="file"
              multiple
              accept="image/x-png, image/png, image/jpeg, video/*"
              @change="uploadFromInput"
            />
          </button>

          <div class="iu-widget-upload__hint">
            <span class="iu-widget-upload__hint--desktop">
              Допустимые форматы: .jpg, .png, .mp4, .mov, не более 5 файлов
            </span>
            <span class="iu-widget-upload__hint--mobile">
              Не более 5 файлов
            </span>
          </div>
        </div>
        <div
          v-if="uploadProcess || uploadedFiles.length"
          class="iu-widget-preview"
        >
          <div v-if="uploadProcess" class="iu-widget-upload__progress">
            <div class="iu-widget-upload__loader">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.3334 1.66699C19.4493 1.66699 18.6015 2.01818 17.9764 2.6433C17.3512 3.26842 17 4.11627 17 5.00032C17 5.88438 17.3512 6.73223 17.9764 7.35735C18.6015 7.98247 19.4493 8.33366 20.3334 8.33366C21.2174 8.33366 22.0653 7.98247 22.6904 7.35735C23.3155 6.73223 23.6667 5.88438 23.6667 5.00032C23.6667 4.11627 23.3155 3.26842 22.6904 2.6433C22.0653 2.01818 21.2174 1.66699 20.3334 1.66699ZM20.3334 32.5003C19.6703 32.5003 19.0345 32.7637 18.5656 33.2326C18.0968 33.7014 17.8334 34.3373 17.8334 35.0003C17.8334 35.6634 18.0968 36.2992 18.5656 36.7681C19.0345 37.2369 19.6703 37.5003 20.3334 37.5003C20.9964 37.5003 21.6323 37.2369 22.1011 36.7681C22.57 36.2992 22.8334 35.6634 22.8334 35.0003C22.8334 34.3373 22.57 33.7014 22.1011 33.2326C21.6323 32.7637 20.9964 32.5003 20.3334 32.5003ZM35.5 18.8337C35.058 18.8337 34.6341 19.0093 34.3215 19.3218C34.009 19.6344 33.8334 20.0583 33.8334 20.5003C33.8334 20.9424 34.009 21.3663 34.3215 21.6788C34.6341 21.9914 35.058 22.167 35.5 22.167C35.9421 22.167 36.366 21.9914 36.6786 21.6788C36.9911 21.3663 37.1667 20.9424 37.1667 20.5003C37.1667 20.0583 36.9911 19.6344 36.6786 19.3218C36.366 19.0093 35.9421 18.8337 35.5 18.8337ZM5.33337 17.0003C4.93941 17.0003 4.5493 17.0779 4.18532 17.2287C3.82135 17.3794 3.49063 17.6004 3.21205 17.879C2.93348 18.1576 2.7125 18.4883 2.56174 18.8523C2.41097 19.2162 2.33337 19.6064 2.33337 20.0003C2.33337 20.3943 2.41097 20.7844 2.56174 21.1484C2.7125 21.5124 2.93348 21.8431 3.21205 22.1216C3.49063 22.4002 3.82135 22.6212 4.18532 22.772C4.5493 22.9227 4.93941 23.0003 5.33337 23.0003C5.72734 23.0003 6.11745 22.9227 6.48143 22.772C6.8454 22.6212 7.17612 22.4002 7.4547 22.1216C7.73327 21.8431 7.95425 21.5124 8.10501 21.1484C8.25578 20.7844 8.33337 20.3943 8.33337 20.0003C8.33337 19.6064 8.25578 19.2162 8.10501 18.8523C7.95425 18.4883 7.73327 18.1576 7.4547 17.879C7.17612 17.6004 6.8454 17.3794 6.48143 17.2287C6.11745 17.0779 5.72734 17.0003 5.33337 17.0003ZM31 5.16699C29.895 5.16699 28.8352 5.60598 28.0538 6.38738C27.2724 7.16878 26.8334 8.22859 26.8334 9.33366C26.8334 10.4387 27.2724 11.4985 28.0538 12.2799C28.8352 13.0613 29.895 13.5003 31 13.5003C32.1051 13.5003 33.1649 13.0613 33.9463 12.2799C34.7277 11.4985 35.1667 10.4387 35.1667 9.33366C35.1667 8.22859 34.7277 7.16878 33.9463 6.38738C33.1649 5.60598 32.1051 5.16699 31 5.16699ZM9.66671 27.667C8.87106 27.667 8.108 27.9831 7.54539 28.5457C6.98278 29.1083 6.66671 29.8713 6.66671 30.667C6.66671 31.4626 6.98278 32.2257 7.54539 32.7883C8.108 33.3509 8.87106 33.667 9.66671 33.667C10.4624 33.667 11.2254 33.3509 11.788 32.7883C12.3506 32.2257 12.6667 31.4626 12.6667 30.667C12.6667 29.8713 12.3506 29.1083 11.788 28.5457C11.2254 27.9831 10.4624 27.667 9.66671 27.667ZM31 28.667C30.7374 28.667 30.4773 28.7187 30.2347 28.8192C29.992 28.9197 29.7715 29.0671 29.5858 29.2528C29.4001 29.4385 29.2528 29.659 29.1523 29.9016C29.0518 30.1443 29 30.4043 29 30.667C29 30.9296 29.0518 31.1897 29.1523 31.4324C29.2528 31.675 29.4001 31.8955 29.5858 32.0812C29.7715 32.2669 29.992 32.4142 30.2347 32.5147C30.4773 32.6153 30.7374 32.667 31 32.667C31.2627 32.667 31.5228 32.6153 31.7654 32.5147C32.0081 32.4142 32.2285 32.2669 32.4143 32.0812C32.6 31.8955 32.7473 31.675 32.8478 31.4324C32.9483 31.1897 33 30.9296 33 30.667C33 30.4043 32.9483 30.1443 32.8478 29.9016C32.7473 29.659 32.6 29.4385 32.4143 29.2528C32.2285 29.0671 32.0081 28.9197 31.7654 28.8192C31.5228 28.7187 31.2627 28.667 31 28.667ZM9.66671 6.33366C9.27274 6.33366 8.88263 6.41126 8.51866 6.56202C8.15468 6.71278 7.82396 6.93376 7.54539 7.21234C7.26681 7.49091 7.04583 7.82163 6.89507 8.18561C6.74431 8.54958 6.66671 8.93969 6.66671 9.33366C6.66671 9.72762 6.74431 10.1177 6.89507 10.4817C7.04583 10.8457 7.26681 11.1764 7.54539 11.455C7.82396 11.7336 8.15468 11.9545 8.51866 12.1053C8.88263 12.2561 9.27274 12.3337 9.66671 12.3337C10.0607 12.3337 10.4508 12.2561 10.8148 12.1053C11.1787 11.9545 11.5095 11.7336 11.788 11.455C12.0666 11.1764 12.2876 10.8457 12.4383 10.4817C12.5891 10.1177 12.6667 9.72762 12.6667 9.33366C12.6667 8.93969 12.5891 8.54958 12.4383 8.18561C12.2876 7.82163 12.0666 7.49091 11.788 7.21234C11.5095 6.93376 11.1787 6.71278 10.8148 6.56202C10.4508 6.41126 10.0607 6.33366 9.66671 6.33366Z"
                  fill="#000"
                />
              </svg>
            </div>
            <span class="iu-widget-upload__loader-description">
              <span class="loader-description__files-count">
                Обработаны {{ filesProcessed }} из
                {{ filesToUpload.length }} фото.
              </span>
              <span
                v-if="isVideoCompression"
                class="loader-description__load-process"
              >
                Сжатие медиа
              </span>
              <span v-else class="loader-description__load-process">
                Загрузка медиа
              </span>
            </span>
          </div>
          <div class="iu-widget__media-list">
            <div
              v-for="(media, index) in uploadedFiles"
              :key="media.id"
              class="iu-widget__media-item"
            >
              <img
                ref="uploadedImages"
                :src="media.url"
                class="iu-widget-item-image"
                @error="reloadImage(index, media.url)"
              />
              <div
                class="iu-widget-item-close"
                @click="uploadedFiles.splice(index, 1)"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.1875 3.5H1.3125C1.18475 3.5 1.0799 3.45902 0.997937 3.37706C0.915979 3.2951 0.875 3.19025 0.875 3.0625C0.875 2.93475 0.915979 2.8299 0.997937 2.74794C1.0799 2.66598 1.18475 2.625 1.3125 2.625H4.8125V1.3125C4.8125 1.18475 4.85348 1.0799 4.93544 0.997937C5.0174 0.915979 5.12225 0.875 5.25 0.875H8.75C8.87775 0.875 8.9826 0.915979 9.06456 0.997937C9.14652 1.0799 9.1875 1.18475 9.1875 1.3125V2.625H12.6875C12.8153 2.625 12.9201 2.66598 13.0021 2.74794C13.084 2.8299 13.125 2.93475 13.125 3.0625C13.125 3.19025 13.084 3.2951 13.0021 3.37706C12.9201 3.45902 12.8153 3.5 12.6875 3.5H11.8125V12.6875C11.8125 12.8153 11.7715 12.9201 11.6896 13.0021C11.6076 13.084 11.5028 13.125 11.375 13.125H2.625C2.49725 13.125 2.3924 13.084 2.31044 13.0021C2.22848 12.9201 2.1875 12.8153 2.1875 12.6875V3.5ZM8.3125 2.625V1.75H5.6875V2.625H8.3125ZM3.0625 12.25H10.9375V3.5H3.0625V12.25ZM5.6875 10.5C5.55975 10.5 5.4549 10.459 5.37294 10.3771C5.29098 10.2951 5.25 10.1903 5.25 10.0625V5.6875C5.25 5.55975 5.29098 5.4549 5.37294 5.37294C5.4549 5.29098 5.55975 5.25 5.6875 5.25C5.81525 5.25 5.9201 5.29098 6.00206 5.37294C6.08402 5.4549 6.125 5.55975 6.125 5.6875V10.0625C6.125 10.1903 6.08402 10.2951 6.00206 10.3771C5.9201 10.459 5.81525 10.5 5.6875 10.5ZM8.3125 10.5C8.18475 10.5 8.0799 10.459 7.99794 10.3771C7.91598 10.2951 7.875 10.1903 7.875 10.0625V5.6875C7.875 5.55975 7.91598 5.4549 7.99794 5.37294C8.0799 5.29098 8.18475 5.25 8.3125 5.25C8.44025 5.25 8.5451 5.29098 8.62706 5.37294C8.70902 5.4549 8.75 5.55975 8.75 5.6875V10.0625C8.75 10.1903 8.70902 10.2951 8.62706 10.3771C8.5451 10.459 8.44025 10.5 8.3125 10.5Z"
                    fill="#C45656"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!uploadProcess && error"
          class="iu-widget-message iu-widget-upload__error"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16ZM12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6L10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13L12 6Z"
              fill="#2C2C2C"
            />
          </svg>
          <span>{{ error }}</span>
        </div>

        <div class="iu-widget__controls">
          <div class="iu-widget-checkboxes">
            <label class="iu-widget-checkbox">
              <input v-model="agreedWithRules" type="checkbox" />
              <div
                class="iu-widget-checkbox__toggle"
                :class="{
                  'iu-widget-checkbox__toggle--checked': agreedWithRules,
                }"
              ></div>
              <div
                v-if="settings.personal_data_agreement_content"
                class="iu-widget-checkbox__label"
                v-html="settings.personal_data_agreement_content"
              ></div>
              <div v-else class="iu-widget-checkbox__label">
                Я ознакомился и согласен с
                <a
                  :href="settings.link_personal_data_agreement"
                  target="_blank"
                >
                  правилами магазина
                </a>
              </div>
            </label>

            <label
              v-if="settings['show_subscription'] === '1'"
              class="iu-widget-checkbox iu-widget-checkbox--subscription"
            >
              <input v-model="subscribtionCheckbox" type="checkbox" />
              <div
                class="iu-widget-checkbox__toggle"
                :class="{
                  'iu-widget-checkbox__toggle--checked': subscribtionCheckbox,
                }"
              ></div>
              <div
                v-html="subscriptionText"
                class="iu-widget-checkbox__label"
              ></div>
            </label>
          </div>

          <button
            class="iu-widget__next-button"
            :class="{
              'iu-widget__next-button--disabled':
                uploadProcess || !agreedWithRules,
            }"
            @click="saveAsPost"
          >
            Отправить
          </button>
        </div>
      </template>
      <template v-else>
        <div class="iu-widget-message iu-widget-message-congrats">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM15.9069 9.00691C16.2974 8.61639 16.2974 7.98322 15.9069 7.5927C15.5164 7.20217 14.8832 7.20217 14.4927 7.5927L9.7998 12.2856L7.50691 9.9927C7.11639 9.60217 6.48322 9.60217 6.0927 9.9927C5.70217 10.3832 5.70217 11.0164 6.0927 11.4069L9.0927 14.4069C9.48322 14.7974 10.1164 14.7974 10.5069 14.4069L15.9069 9.00691Z"
              fill="#2C2C2C"
            />
          </svg>
          <span>
            Отзыв успешно отправлен на модерацию.
            <span>Вы получите уведомление на почту.</span>
          </span>
        </div>
      </template>
      <div
        v-if="inDrag"
        class="iu-widget-drop-area"
        :class="{
          'iu-widget-drop-area--limited': limitIsFull || uploadProcess,
        }"
      >
        <svg
          width="134"
          height="134"
          viewBox="0 0 134 134"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M67 122.834C97.8359 122.834 122.833 97.8362 122.833 67.0003C122.833 36.1644 97.8359 11.167 67 11.167C36.1641 11.167 11.1667 36.1644 11.1667 67.0003C11.1667 97.8362 36.1641 122.834 67 122.834Z"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M67 39.083L67 94.9163"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M39.0833 67L94.9166 67"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
// Modules
import axios from "axios";
// Mixins
import analytics from "../../common/mixins/analytics";
// Components
import StarRating from "./components/StarRating.vue";
import GuideButton from "../letoile_official/GuideButton.vue";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { redirectToAuthPage } from "../services";

export default {
  mixins: [analytics],

  // NOTE: StarRating uses as hot-fix. See "NOTE" into the component
  components: { StarRating, GuideButton },

  props: ["propSettings"],
  data() {
    // TODO: Refactor next line
    const { logged_in_email, logged_in_id } = this.propSettings;

    return {
      settings: this.propSettings || {},
      maxLimit: 5,
      isShow: true,
      currentStep: "upload",
      filesToUpload: null,
      filesProcessed: 0,
      uploadedFiles: [],
      uploadProcess: false,
      error: null,
      username: logged_in_id || "",
      email: logged_in_email || "",
      rating: 0,
      positiveComment: "",
      negativeComment: "",
      caption: "",
      agreedWithRules: false,
      inDrag: false,
      labelItemPosition: ["url", "friPostId", "uploadPhotoCount"],
      categoryPostfix: "IUpload",
      isGuidlineOpen: false,
      isContentRulesOpen: false,
      isVideoCompression: false,

      subscribtionCheckbox: false,
      subscriptionText:
        this.propSettings["subscription_text"] || "Подписаться на рассылку",

      emailReg:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      textareaMaxLength: 4000,
    };
  },

  mounted() {
    document.addEventListener("frisbuy:iu-open", this.showPopup);

    // #region sonata's scripts
    window.frisbuy.sonata = {
      openGuide: this.openGuide,
      openContentRules: this.openContentRules,
    };
    // #endregion sonata's scripts
  },
  beforeUnmount() {
    document.removeEventListener("frisbuy:iu-open", this.showPopup);
  },

  computed: {
    limitIsFull() {
      const { uploadedFiles, maxLimit } = this;

      return uploadedFiles.length >= maxLimit;
    },

    trackingSkuId: function () {
      const { skuId, groupId, categoryId } = this.settings;

      return (
        (skuId && `_sku${skuId}`) ||
        (groupId && `_skug${groupId}`) ||
        (categoryId && `_cat${categoryId}`) ||
        ""
      );
    },

    widgetTitle() {
      return this.settings.widgetTitle || "Добавить отзыв";
    },

    isUserLoggedIn() {
      const { logged_in_id, logged_in_email, logged_in_phone } = this.settings;

      return !!logged_in_id && !!logged_in_email && !!logged_in_phone;
    },
  },

  watch: {
    currentStep(newStepName, oldStepName) {
      if (newStepName === "post") {
        this.sendAnalyticEvent("UplphotoUploaded", {
          link: location.href,
          linklabel: document.title,
        });
      }

      if (oldStepName === "upload") return;

      this.error = null;
    },

    isShow: {
      handler(value) {
        const { logged_in_email, logged_in_id } = this.settings;

        if (value) {
          this.sendAnalyticEvent("UplphotoOpen");

          if (this.settings.auth_page_url && !this.isUserLoggedIn) {
            const backUrl = window.location.href;
            redirectToAuthPage(this.settings.auth_page_url, backUrl);

            this.closePopup();
            return;
          }

          this.$nextTick(() => {
            const { $el } = this;

            document.body.appendChild($el);

            this.lockWindowScroll();
          });

          return;
        }

        this.unlockWindowScroll();

        this.currentStep = "upload";
        this.filesToUpload = null;
        this.filesProcessed = 0;
        this.uploadedFiles = [];
        this.uploadProcess = false;
        this.error = null;
        this.username = this.username || logged_in_id || "";
        this.email = this.email || logged_in_email || "";
        this.agreedWithRules = false;
      },

      immediate: true,
    },
  },

  methods: {
    lockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "hidden";
    },

    unlockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "";
    },

    showPopup() {
      this.isShow = true;
    },

    closePopup() {
      this.toggleGuide();
      this.closeContentRules();

      this.isShow = false;
      this.subscribtionCheckbox = false;
    },

    clearForm() {
      this.email = "";
      this.username = "";
      this.logged_in_id = "";
      this.rating = 0;
      this.positiveComment = "";
      this.negativeComment = "";
      this.caption = "";
    },

    componentAction({ action }) {
      const { settings, trackingSkuId } = this;

      return `${action}_embedID${settings.embedId + trackingSkuId}`;
    },

    uploadFromDrop(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.dataTransfer;

      this.inDrag = false;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFromInput(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.target;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFiles() {
      const { filesToUpload, settings } = this;
      const { srcDomain, embedId } = settings;

      this.uploadProcess = true;
      this.filesProcessed = 0;
      this.error = null;

      filesToUpload.forEach((file) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        if (file.size > 50 * 1024 * 1024) {
          this.filesProcessed += 1;
          this.error = (this.error || "") + "Файл превышает размер 50 мегабайт";

          if (this.filesProcessed !== filesToUpload.length) return;

          this.uploadProcess = false;
          this.filesToUpload = [];
          this.currentStep = "preview";

          return;
        }

        axios({
          url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/medias?embed_id=${embedId}`),
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progress) => {
            const isUploaded = progress.total === progress.loaded;

            if (isUploaded) {
              this.isVideoCompression = true;
            }
          },
        })
          .then(({ data }) => {
            const { request, response } = data;
            const { success, statusMessage } = request;
            const { post_media } = response.body;

            if (!success) {
              this.error = statusMessage;
              return;
            }

            this.uploadedFiles.push(post_media);
          })
          .catch((error) => {
            const { response } = error;

            this.sendAnalyticEvent("UplphotoError", {
              link: location.href,
              linklabel: document.title,
              error: this.error,
            });

            if (!response || typeof response.data.request === "string") {
              if (error && response && response.status === 413) {
                this.error =
                  (this.error || "") +
                  `Файл '${file.name}' превышает размер 50 мегабайт` +
                  "\n";
                return;
              }

              this.error = "Ошибка на сервере, попробуйте позже";
              return;
            }

            if (this.error === null) {
              this.error = `${response.data.request.error}\n`;
            } else {
              this.error += `${response.data.request.error}\n`;
            }
          })
          .finally(() => {
            this.filesProcessed += 1;

            if (this.filesProcessed !== filesToUpload.length) return;

            this.uploadProcess = false;
            this.isVideoCompression = false;
            this.filesToUpload = [];
            this.currentStep = "preview";
          });
      });
    },

    saveAsPost() {
      let {
        uploadedFiles,
        username,
        email,
        rating,
        positiveComment,
        negativeComment,
        caption,
        agreedWithRules,
        settings,
      } = this;
      const { srcDomain, embedId, logged_in_id } = settings;
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      username = username.trim();
      email = email.trim();
      this.error = null;

      if (!username) {
        this.error = "Пожалуйста, введите имя";
        return;
      } else if (!email || !emailReg.test(email)) {
        this.error = "Пожалуйста, введите правильный E-mail адрес";
        return;
      } else if (!rating) {
        this.error = "Пожалуйста, оставьте свою оценку";
        return;
      } else if (
        !positiveComment &&
        !negativeComment &&
        !caption &&
        !uploadedFiles.length
      ) {
        this.error =
          "Пожалуйста, расскажите о впечатлениях. Заполните хотя бы одно поле, либо прикрепите фото или видео о товаре";
        return;
      } else if (!agreedWithRules) {
        this.error =
          "Пожалуйста, подтвердите ознакомление с правилами пользования сайтом";
        return;
      }

      let url = `${srcDomain}/api/1.0.0/customer/reviews?embed_id=${embedId}`;

      if (this.settings.groupId) {
        url = url + `&group=${this.settings.groupId}`;
      }

      axios({
        url: DomainSubstitute(url),
        method: "POST",
        data: {
          post_medias: uploadedFiles,
          email,
          username,
          logged_in_id,
          rating,
          positiveComment,
          negativeComment,
          caption,
          url: encodeURIComponent(location.href),
        },
      })
        .then(({ data }) => {
          const { success, statusMessage } = data.request;

          if (!success) {
            this.error = statusMessage;
            return;
          }

          if (this.settings["show_subscription"] && this.subscribtionCheckbox) {
            this.makeEventForClient("subscribe-on-newsletter", {
              email,
            });
          }

          this.sendAnalyticEvent("UplphotoOK", {
            url: location.href,
            uploadPhotoCount: uploadedFiles.length,
            link: location.href,
            linklabel: document.title,
          });

          this.currentStep = "congrats";
          this.clearForm();

          setTimeout(() => {
            this.closePopup();
          }, 3000);
        })
        .catch((error) => {
          const { response } = error;

          this.sendAnalyticEvent("UplphotoError", {
            link: location.href,
            linklabel: document.title,
            error: this.error,
          });

          if (response) {
            const { data } = response;

            this.error = data.request.error;
          } else {
            this.error = "Ошибка на сервере, попробуйте позже";
          }
        });
    },

    makeEventForClient(eventName, data, eventNamePrefix = "frisbuy") {
      const resultEventName = `${eventNamePrefix}:${eventName}`;

      document.dispatchEvent(
        new CustomEvent(resultEventName, { detail: data })
      );
    },

    reloadImage(index, url) {
      /*
        NOTE: Backend cache return 404 error.
        To update cache I use random query param
      */
      const randomValue = Math.random().toString().slice(2);
      const randomQueryParam = `random_query_param=${randomValue}`;

      const fixedUrl = `${url}?recovery=true&${randomQueryParam}`;
      this.$refs.uploadedImages[index].src = fixedUrl;
    },

    toggleGuide() {
      this.isGuidlineOpen = false;

      if (!this.isGuideFromIU) {
        this.isShow = false;
      } else {
        this.isGuideFromIU = false;
      }
    },
    openGuide() {
      if (!this.settings.html_guideline_block) {
        return;
      }

      this.isGuideFromIU = true;
      this.isGuidlineOpen = true;
    },

    closeContentRules() {
      this.isContentRulesOpen = false;
    },
    openContentRules() {
      if (!this.settings.html_content_rules_block) {
        return;
      }

      this.isContentRulesOpen = true;
    },
  },
};
</script>

<style src="../style.scss" lang="scss"></style>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap");

$primaryColor: #303133;
$secondaryColor: #909399;
$errorColor: #f56c6c;
$textColor: #606266;
$textColorPlaceholder: #a8abb2;
$borderColor: #dcdfe6;

.iu-widget__overlay {
  background-color: rgba(77, 77, 77, 0.4);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100svw;
  min-height: 100svh;
  z-index: 99999999999999;
  animation: iu-show 0.2s linear;
  color: #2c2c2c;
  font-family: Inter, sans-serif;
  overflow: auto;

  * {
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-thumb {
      background: #a4a4a4;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-thumb:hover,
    &::-webkit-scrollbar-thumb:active {
      background: #a4a4a4;
    }

    &::-webkit-scrollbar-track {
      background: #ffffff;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-track:hover,
    &::-webkit-scrollbar-track:active {
      background: #ffffff;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid #c0c0c0;
  }

  &.iu-widget--in-drag {
    .iu-widget__popup {
      pointer-events: none;
    }
  }
}

.iu-widget__popup {
  width: 846px;
  background: #ffffff;
  padding: 20px;
  position: relative;
  max-height: 97svh;
  overflow: auto;

  .iu-widget__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    height: 32px;

    .iu-widget__title {
      font-family: Roboto;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0;
      vertical-align: middle;
    }

    .iu-widget__close {
      position: relative;

      // height: 100%;
      // aspect-ratio: 1 / 1;

      background-color: transparent;
      border: none;

      padding: 4px;
      margin: auto 0;

      cursor: pointer;

      svg {
        vertical-align: middle;
      }
    }
  }

  .iu-widget__post-form {
    & > * {
      margin-top: 16px;

      &:last-child {
        margin-bottom: 16px;
      }
    }

    label {
      color: $textColor;

      font-family: Inter;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 0px;

      &::after {
        color: $primaryColor;
      }
    }

    .iu-widget--required {
      &:after {
        content: "*";
        color: $errorColor;
      }
    }

    .--error {
      border-color: $errorColor;
    }

    input,
    textarea {
      height: 32px;

      color: $textColor;

      border: 1px solid $borderColor;
      border-radius: 2px;

      font-family: Inter;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 0px;

      padding: 4px 12px;

      &::placeholder {
        color: $textColorPlaceholder;
      }

      &.input--error {
        border: 1px solid $errorColor;
      }
    }

    .post-form__person-info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 12px;

      .input-form {
        display: flex;
        flex-direction: column;

        gap: 8px 0;

        &,
        input {
          width: 100%;
        }
      }
    }

    .post-form__customer-rating {
      display: flex;
      flex-direction: column;

      gap: 4px 0;

      label {
        font-family: Inter;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;

        color: $primaryColor;
      }
    }

    .post-form__customer-review {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      gap: 12px 0;

      .customer-review__title {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 4px;

        align-items: center;
        vertical-align: middle;

        color: $primaryColor;

        font-family: Roboto;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0;

        .customer-review__description {
          white-space: nowrap;

          color: $secondaryColor;

          font-family: Inter;
          font-size: 12px;
          line-height: 20px;
        }
      }

      .customer-review__positive,
      .customer-review__negative,
      .customer-review__comment {
        display: flex;
        flex-direction: row;

        align-items: center;

        svg {
          flex: 0 0 auto;

          width: 24px;
          height: 24px;

          margin-right: 7px;
        }

        textarea {
          width: 100%;
          max-width: 100%;
          min-height: 32px;
          max-height: 250px;

          resize: vertical;
        }
      }

      .customer-review__comment {
        textarea {
          min-height: 58px;
        }
      }
    }
  }

  .iu-widget-upload {
    display: flex;
    position: relative;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    gap: 12px;

    .iu-widget-upload__button {
      display: flex;
      position: relative;
      flex-direction: row;

      justify-content: center;
      align-items: center;

      gap: 0 10px;

      width: 227px;
      min-width: 227px;
      height: 38px;

      border: 1px solid $primaryColor;
      border-radius: 4px;
      background-color: #ffffff;

      padding: 0;

      svg {
        position: relative;

        width: 19px;
        height: 19px;
      }

      .iu-widget-upload__text {
        font-family: Inter;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: center;
      }
    }

    .iu-widget-upload__hint {
      font-size: 12px;
      line-height: 16px;
      color: #5e5e5e;
      text-align: left;

      .iu-widget-upload__hint--mobile {
        display: none;
      }
    }

    + .iu-widget-upload__error {
      margin-top: 16px;

      span {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    input {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      cursor: pointer;
    }
  }
}

.iu-widget-drop-area {
  position: absolute;
  background-color: rgba(30, 129, 189, 0.15);
  backdrop-filter: blur(5px);
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.iu-widget-drop-area--limited {
    background-color: rgba(189, 30, 30, 0.15);
    svg {
      transform: rotate(45deg);
    }
  }
}

.iu-widget-preview {
  margin: 5px 0 0;
}

.iu-widget-upload__loader {
  svg {
    margin-right: 20px;
    animation: spin 1s infinite linear;
  }
}

.iu-widget-upload__progress {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 18px 6px;
  color: #959595;
  font-size: 13px;
  line-height: 22px;
}

.iu-widget-upload__loader-description {
  .loader-description__load-process {
    white-space: nowrap;
  }
}

.iu-widget__media-list {
  $spaceBetweenMediaItems: 9px;

  display: flex;
  flex-wrap: wrap;

  gap: $spaceBetweenMediaItems;

  .iu-widget__media-item {
    position: relative;

    width: calc((1 / 3 * 100%) - ($spaceBetweenMediaItems * 2 / 3));
    height: auto;
    max-width: 107px;
    max-height: 107px;
    aspect-ratio: 1 / 1;

    background-color: #eaeaea;
    background-size: cover;

    .iu-widget-item-close {
      display: flex;
      position: absolute;
      justify-content: center;
      align-items: center;

      inset: auto 2px 4px auto;

      width: 32px;
      height: 32px;

      background: #ffffff;
      border-radius: 4px;

      cursor: pointer;

      svg {
        width: 14px;
        height: 14px;
      }
    }

    .iu-widget-item-image {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
}

.iu-widget__controls {
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 16px;

  .iu-widget-checkboxes {
    width: 100%;

    .iu-widget-checkbox {
      display: flex;
      position: relative;

      align-items: center;
      gap: 0 8px;

      input[type="checkbox"],
      .iu-widget-checkbox__toggle {
        width: 14px;
        height: 14px;
        aspect-ratio: 1;

        cursor: pointer;

        margin: 0;
      }

      input[type="checkbox"] {
        position: absolute;
        opacity: 0;

        &:checked + .iu-widget-checkbox__toggle:before {
          content: "";
          width: 6px;
          height: 4px;
          border-width: 0 0 2px 2px;
          border-style: solid;
          border-color: #ffffff;
          border-radius: 2px;
          transform: rotate(-45deg);
          margin: -3px 0 0;
        }
      }

      .iu-widget-checkbox__toggle {
        display: flex;
        align-items: center;
        justify-content: center;

        border: 1px solid $borderColor;
        border-radius: 2px;

        &.iu-widget-checkbox__toggle--checked {
          border: 0;
          background-color: #409eff;
        }
      }

      .iu-widget-checkbox__label {
        color: $textColor;

        font-family: Inter;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0;
        text-align: left;
      }
    }
  }

  .iu-widget__next-button {
    display: inline-block;

    width: 312px;
    height: 48px;

    color: #ffffff;
    background: #141313;

    font-family: Inter;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;

    border: 0;
    border-radius: 2px;

    cursor: pointer;

    padding: 12px 40px;

    &.iu-widget__next-button--disabled {
      opacity: 0.5;
      pointer-events: none;
      box-shadow: none;
    }
  }
}

.iu-widget-message {
  background-color: #f4f4f4;
  padding: 18px 26px;
  display: flex;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;

  svg {
    margin-right: 14px;
    flex-shrink: 0;
  }
}

.iu-widget-upload__error {
  margin-top: 24px;

  background-color: #fcd8d9;

  & + .iu-widget-preview {
    margin-top: 0;
  }
}

.iu-widget-message-congrats {
  span {
    display: block;
  }
}

// media queries
@media (max-width: 720px) {
  .iu-widget__popup {
    max-width: 640px;
  }
}

@media (max-width: 640px) {
  .iu-widget__controls {
    flex-direction: column;
    gap: 16px 0;

    .iu-widget__next-button {
      width: 100%;
    }
  }
}

@media (max-width: 340px) {
  .iu-widget__popup {
    .iu-widget__post-form {
      .post-form__person-info {
        flex-direction: column;
      }
    }
  }
}
</style>
